import { styled } from '@abyss/web/tools/styled';

const MainContainer = styled('main', {
  padding: '0',
  backgroundColor: '#ffffff',
  minHeight: 'auto',
});

const FooterContainer = styled('div', {
  padding: '0 !important',
  backgroundColor: '$primary1',
  marginLeft: '0',
  marginTop: 'auto',
  width: '100%',
  minHeight: 'auto',
  flexShrink: 0,
  position: 'relative',
  zIndex: 1200,
});

export { MainContainer, FooterContainer };
